"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseForm = function (_Component) {
    (0, _inherits3.default)(BaseForm, _Component);

    function BaseForm(props, context) {
        (0, _classCallCheck3.default)(this, BaseForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseForm.__proto__ || (0, _getPrototypeOf2.default)(BaseForm)).call(this, props, context));

        _this.changeField = _this.changeField.bind(_this);

        if (!(typeof _this.changeField === 'function')) {
            throw new TypeError("Value of \"this.changeField\" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n" + _inspect(_this.changeField));
        }

        _this.onSubmit = _this.onSubmit.bind(_this);

        if (!(typeof _this.onSubmit === 'function')) {
            throw new TypeError("Value of \"this.onSubmit\" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n" + _inspect(_this.onSubmit));
        }

        _this.isValid = _this.isValid.bind(_this);

        if (!(typeof _this.isValid === 'function')) {
            throw new TypeError("Value of \"this.isValid\" violates contract.\n\nExpected:\n() => any\n\nGot:\n" + _inspect(_this.isValid));
        }

        return _this;
    }

    (0, _createClass3.default)(BaseForm, [{
        key: "onSubmit",
        value: function onSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: "isValid",


        /**
         * Валидация по всем методам проверки
         *
         * @returns {boolean}
         */
        value: function isValid() {
            return true;
        }
    }, {
        key: "changeField",
        value: function changeField(fieldName) {
            var _this2 = this;

            return function (event, value) {
                if (value === undefined) {
                    event.preventDefault();
                    _this2.setState((0, _defineProperty3.default)({}, fieldName, event.target.value), function () {
                        if (_this2.props.onChange) {
                            _this2.props.onChange(_this2.state);
                        }
                    });
                } else {
                    _this2.setState((0, _defineProperty3.default)({}, fieldName, value), function () {
                        if (_this2.props.onChange) {
                            _this2.props.onChange(_this2.state);
                        }
                    });
                }
            };
        }
    }]);
    return BaseForm;
}(_react.Component);

exports.default = BaseForm;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === "undefined" ? "undefined" : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseForm.jsx
// module id = 66
// module chunks = 0